// extracted by extract-css-chunks-webpack-plugin
module.exports = {"control":"control_1-77u","control__count":"control__count_29ZsE","control__add":"control__add_2AoLP"};